import { SET_SELECTED_ISSUE } from 'actions';
import { IIssue } from 'typings';

export function setSelectedIssue(selectedIssue?: IIssue) {
  return { selectedIssue, type: SET_SELECTED_ISSUE };
}
